import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initGa, trackPageView } from '@/lib/analytics/ga';

/**
 * Sender page_view til GA4 ved hvert route-skift (SPA).
 * Admin-ruter tælles ikke med, så interne besøg ikke forvrider tallene.
 */
export function useGaPageViews() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    initGa();
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    // Den første sidevisning sendes af gtag-konfigurationen. Hvis brugeren
    // først accepterer statistik senere, sender consent-flowet den i stedet.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // Lad titlen blive opdateret af siden først.
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
}
